import { DateTime } from 'luxon'

const formatDate = (dateString, currentFormat, exportFormat = 'yyyy-MM-dd') => {
  if (!dateString) return ''

  const date = DateTime.fromFormat(dateString, currentFormat)

  if (exportFormat === 'ISO'){
    return date.toISO()
  }

  return date.toFormat(exportFormat)
}

export const formatToDateTime = (dateTimeString, currentFormat = 'dd/MM/yyyy HH:mm') => (
  formatDate(dateTimeString, currentFormat, "yyyy-MM-dd'T'HH:mm")
)

export default formatDate
